import { TextWithContentModel } from '../../model/TextWithContentModel';
import { CDNImage } from 'shared-widget-components/src/components/CDNImage/CDNImage';

interface CoverImagePreviewProps {
  content: TextWithContentModel;
}

export const CoverImagePreview = ({ content }: CoverImagePreviewProps) => {
  if (content.mediaType !== 3) return null;
  return (
    <div className='coverimage w-full md:w-1/2 min-[350px]:px-5 sm:px-0'>
      {content.coverImageContent[0] && content.coverImageContent[0].url && (
        <CDNImage src={content.coverImageContent[0].url} alt={content.coverImageContent[0].alt} imageWidth={525} imageHeight={350} fit='crop' className='mx-auto md:mx-0' />
      )}
    </div>
  );
};
